import versionFile from '../../version.json'
import isProduction from './isProduction'

type VersionFile = {
  version?: string
  build?: string
  date?: string
  commit?: string
}

const { version, build, date, commit } = versionFile as VersionFile

/**
 * Строка о сборке для подвала и экрана входа: «1.299.0-dev.5 · 30.10.2026».
 * build — имя релиза, его дописывает CI (под ним же релиз лежит на сервере);
 * version в version.json поднимают разработчики. В локальной сборке build нет —
 * тогда версия из version.json с пометкой (dev).
 */
export const buildInfo =
  [build || version, date].filter(Boolean).join(' · ') + (build || isProduction() ? '' : ' (dev)')

/** Имя релиза для показа: «1.299.0-dev.5»; локально — версия из version.json */
export const buildName = build || version || ''

/** Подсказка при наведении на строку о сборке */
export const buildTitle = commit ? `commit ${commit}` : undefined
